import React from "react";
import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer } from "recharts";

export default function PillarRadar({ pillars, height = 320 }) {
  const data = [
    { axis: "STRENGTH", value: pillars?.strength ?? 0, full: 100 },
    { axis: "SPEED", value: pillars?.speed ?? 0, full: 100 },
    { axis: "EXPLOSIVE", value: pillars?.explosive ?? 0, full: 100 },
    { axis: "STAMINA", value: pillars?.stamina ?? 0, full: 100 },
    { axis: "CONTROL", value: pillars?.control ?? 0, full: 100 },
  ];
  return (
    <div className="relative" data-testid="pillar-radar">
      <ResponsiveContainer width="100%" height={height}>
        <RadarChart data={data} outerRadius="78%">
          <PolarGrid stroke="rgba(255,255,255,0.18)" />
          <PolarAngleAxis
            dataKey="axis"
            tick={{ fill: "#cfd7e0", fontSize: 11, fontFamily: "Tourney, Saira, sans-serif", letterSpacing: 2 }}
          />
          <PolarRadiusAxis
            angle={90}
            domain={[0, 100]}
            tick={{ fill: "rgba(255,255,255,0.4)", fontSize: 9, fontFamily: "JetBrains Mono" }}
            stroke="rgba(255,255,255,0.1)"
          />
          <Radar
            name="GPS"
            dataKey="value"
            stroke="#ffffff"
            fill="#ffffff"
            fillOpacity={0.22}
            strokeWidth={2}
            isAnimationActive
            animationDuration={1400}
          />
        </RadarChart>
      </ResponsiveContainer>
    </div>
  );
}
